import { LoadingButton } from '@mui/lab';
import {
  Alert,
  Avatar,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { FC, useState } from 'react';

import { Close } from '@mui/icons-material';
import { WithdrawIcon } from '../../../../vectors/index';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';

type DeclineJobOfferModalProps = {
  isOpen: boolean;
  errorText: string;
  isRespondingJobOffer: boolean;
  handleClose: () => void;
  handleSubmit: (response: string) => void;
};

const DeclineJobOfferModal: FC<DeclineJobOfferModalProps> = ({
  isOpen,
  errorText,
  isRespondingJobOffer,
  handleClose,
  handleSubmit
}) => {

  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={handleClose}
        >
          <Close />
        </IconButton>
        <br />
        <WithdrawIcon />
        <br />
        <Typography variant="h4">Decline Job Offer</Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={2 } mb={2}>
          {errorText && <Alert severity="error">{errorText}</Alert>}
          <Stack direction="row" mb={2}>
            <Stack>
              <Typography variant="h5" textAlign='center'>
                Are you sure you want to decline this job offer? This cannot be undone.
              </Typography>
            </Stack>
          </Stack>
          <Divider />
          <LoadingButton
            variant="contained"
            color="success"
            onClick={() => handleSubmit('DECLINE')}
            startIcon={<DoneIcon />}
            loading={isRespondingJobOffer}
            disabled={isRespondingJobOffer}
          >
            Confirm
          </LoadingButton>
          <LoadingButton
            variant="contained"
            color="error"
            onClick={handleClose}
            startIcon={<CloseIcon />}
          >
            Go Back
          </LoadingButton>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default DeclineJobOfferModal;
